'use strict'

import { apiInstance, legacyV2, legacyV3 } from './index'
import { mapArgs } from 'utils/functions'

const costCenter = {
  getCostCentersList (limit, page) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/costCenter`,
      params: {
        limit,
        page
      }
    })
  },

  getCostCenterById (costCenterId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV3()}/costCenter/${costCenterId}`
    })
  },

  // args should be something like [{ company: 505}, { page: 1 }]
  getCostCentersAll (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/costCenter`,
      params
    })
  },

  exportCostCenters (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/costCenter/export`,
      timeout: 60000,
      responseType: 'blob',
      params
    })
  },

  deleteCostCenter (costCenterId) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/costCenter/${costCenterId}`
    })
  },

  addToAllEmployees (costCenterId) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/costCenter/${costCenterId}/addToAllEmployees`,
      data: { id: costCenterId }
    })
  },

  addCostCenter (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/costCenter`,
      data
    })
  },

  updateCostCenter (data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3()}/costCenter/${data.id}`,
      data
    })
  },

  addOrEditCostCenter (costCenter) {
    function sanitizeOwners () {
      let sanitized = []
      costCenter.owners.forEach(element => {
        sanitized.push(element.id)
      })
      return sanitized
    }

    costCenter.owners = sanitizeOwners()

    let method
    let url = `${legacyV2()}/costCenter`

    if (costCenter.id) {
      method = 'put'
      url = `${url}/${costCenter.id}`
    } else {
      method = 'post'
      costCenter.new = true
    }

    return apiInstance({
      method,
      url,
      data: costCenter
    })
  }
}

export default costCenter
